<template>
    <div>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="权限名称:" style="margin: 0">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" icon="el-icon-search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-tree
            ref="tree"
            class="filter-tree"
            :data="treedata"
            :props="defaultProps"
            node-key="id"
            :filter-node-method="filterNode"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent"
            show-checkbox
            :default-checked-keys="defaultCheckedKeys"
        >
        </el-tree>
        <div class="boontbtn">
            <el-button
                type="primary"
                size="small"
                style="margin: 0 30px"
                @click="saveData"
                >保存</el-button
            >
            <el-button type="info" size="small" @click="closeDialog"
                >关闭</el-button
            >
        </div>
    </div>
</template>
<script>
import request from "../../../utils/request.js"
export default {
    name: "ViewRight",
    props: ["rowid"],
    data() {
        return {
            id: this.rowid,
            filterText: "",
            treedata: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            menuTypes: [
                { value: "1", label: "模块", disabled: true },
                { value: "2", label: "目录", disabled: true },
                { value: "3", label: "菜单", disabled: true },
                { value: "4", label: "动作", disabled: true },
                { value: "5", label: "数据", disabled: true },
            ],
            defaultCheckedKeys: [],
        }
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
    },
    methods: {
        //树形列表
        filterNode(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        //树形结果显示内容自定义
        renderContent(h, { node, data, store }) {
            return (
                <span class="tree-span">
                    <span class="tree-span-label">
                        <el-tag type={data.css} size="small">
                            {data.tag}
                        </el-tag>
                        &nbsp;&nbsp;
                        {node.label}
                    </span>
                </span>
            )
        },
        //获取该角色下的所有权限树形
        async getData() {
            await this.getTreeDatas()
            let params = JSON.stringify({ id: this.id })
            // console.log(params)
            var res = await request({
                url: "/rbac/admin/menu/info/findMenuByRoleId",
                method: "POST",
                data: params,
            })
            this.defaultCheckedKeys = []
            if (res.code == 200) {
                if (res.content.length > 0) {
                    res.content.forEach((item) => {
                        this.defaultCheckedKeys.push(item.id)
                    })

                    let newArr = []
                    let item = ""
                    if (
                        this.defaultCheckedKeys &&
                        this.defaultCheckedKeys.length !== 0
                    ) {
                        this.defaultCheckedKeys.forEach((id) => {
                            this.checked(id, this.treedata, newArr)
                        })
                        this.defaultCheckedKeys = newArr
                    }
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            }
            //console.log(this.defaultCheckedKeys)
        },
        checked(id, data, newArr) {
            data.forEach((item) => {
                if (item.id == id) {
                    if (item.children && item.children.length == 0) {
                        newArr.push(item.id)
                    }
                } else {
                    if (item.children != null && item.children.length != 0) {
                        this.checked(id, item.children, newArr)
                    }
                }
            })
        },
        //获取树形数据
        async getTreeDatas() {
            this.treedata = []
            var res = await request({
                url: "/rbac/admin/menu/info/getTree",
                method: "POST",
                data: {},
            })
            if (res.content.length > 0) {
                res.content.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.模块 2.目录 3.菜单 4.动作
                    var tag = "模块"
                    var css = ""
                    if (item.menuType == "2") {
                        tag = "目录"
                        css = "info"
                    } else if (item.menuType == "3") {
                        tag = "菜单"
                        css = "danger"
                    } else if (item.menuType == "4") {
                        tag = "动作"
                        css = "warning"
                    } else if (item.menuType == "5") {
                        tag = "数据"
                        css = "success"
                    }
                    this.treedata.push({
                        id: item.id,
                        tag: tag,
                        css: css,
                        value: item.id,
                        label: item.name,
                        children: children,
                    })
                })
            }
            // console.log(this.treedata)
        },
        formateTree(arr) {
            var temp = []
            if (arr.length > 0) {
                arr.forEach((item) => {
                    var children = []
                    if (item.children != null && item.children.length > 0) {
                        children = this.formateTree(item.children)
                    }
                    //1.模块 2.目录 3.菜单 4.动作
                    var tag = "模块"
                    var css = "warning"
                    if (item.menuType == "2") {
                        tag = "目录"
                        css = "info"
                    } else if (item.menuType == "3") {
                        tag = "菜单"
                        css = "danger"
                    } else if (item.menuType == "4") {
                        tag = "动作"
                        css = "warning"
                    } else if (item.menuType == "5") {
                        tag = "数据"
                        css = ""
                    }
                    temp.push({
                        id: item.id,
                        tag: tag,
                        css: css,
                        value: item.id,
                        label: item.name,
                        children: children,
                    })
                })
            }
            return temp
        },
        //保存到数据库
        async saveData() {
            let menuIds = [
                ...this.$refs.tree.getCheckedKeys(),
                ...this.$refs.tree.getHalfCheckedKeys(),
            ]
            console.log(menuIds)
            if (menuIds.length < 1) {
                this.$message({
                    message: "请选择要绑定的权限",
                    type: "error",
                })
                return
            }
            let params = JSON.stringify({ id: this.id, menuIds: menuIds })
            // console.log(params)
            var res = await request({
                url: "/rbac/admin/role/info/updateRoleByRoleIdAndMenuIds",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                this.$message({
                    message: "权限分配成功",
                    type: "success",
                })
                this.$emit("func", [])
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "分配失败：" + res.message,
                    type: "error",
                })
            }
        },
        closeDialog() {
            this.$emit("func", [])
        },
    },
    mounted() {},
}
</script>